import { postStyles } from "./forum-post.styles";
import * as stylex from "@stylexjs/stylex";
import { styles } from "../forum.styles";
import type { ForumPostRecord, ForumMarkdownRenderer } from "../forum.types";
export function ForumPostBody({
  post,
  renderMarkdown,
}: Readonly<{
  post: ForumPostRecord;
  renderMarkdown: ForumMarkdownRenderer;
}>) {
  return (
    <div {...stylex.props(postStyles.articleBody)}>
      {post.content.format === "markdown" ? (
        renderMarkdown({
          body: post.content.body,
          headingSlugs: true,
        })
      ) : post.content.format === "text" ? (
        <p {...stylex.props(postStyles.plainText)}>{post.content.body}</p>
      ) : post.content.format === "deleted" ? (
        <p>[deleted]</p>
      ) : (
        <iframe
          title={post.title}
          src={post.content.src}
          sandbox="allow-same-origin"
          referrerPolicy="no-referrer"
          loading="lazy"
          {...stylex.props(postStyles.renderFrame)}
        />
      )}
      {post.images?.map((image) => (
        <img
          key={image.id}
          src={image.src}
          alt={image.alt}
          {...stylex.props(styles.attachment)}
        />
      ))}
    </div>
  );
}
